import api from '../api';
const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
};

const BASE_URL = process.env.REACT_APP_API_URL;

const DepartmentService = {

  create: async (data) => {
    try {
      const department = await api.post(`${BASE_URL}/department`, data, axiosConfig);
      return department; 
    } catch (error) {
      if(error.response.status === 422){
        throw error.response.data;
      }else{
        console.log("Error in creating department.", [error]);
        throw new Error(error?.response?.data?.message || error?.message || "An error occurred");
      }
    }
  },

  update: async (id, data) => {
    try {
      return await api.put(`${BASE_URL}/department/${id}`, data, axiosConfig);
    } catch (error) {
      console.log("Error in updating department.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  delete: async (id) => {
    try {
      return await api.delete(`${BASE_URL}/department/${id}`, axiosConfig);
    } catch (error) {
      console.log("Error in deleting department.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  get: async (id) => {
    try {
      return await api.get(`${BASE_URL}/department/${id}`, axiosConfig);
    } catch (error) {
      console.log("Error in getting department detail.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  getAll: async () => {
    try {
      return await api.get(`${BASE_URL}/department`, axiosConfig);
    } catch (error) {
      console.log("Error in getting departments.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },
  
  listAll: async () => {
    try {
      return await api.get(`${BASE_URL}/department/list`, axiosConfig);
    } catch (error) {
      console.log("Error in getting departments.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  }
};

export default DepartmentService;
